var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Discrete Distribution")]),_c('discrete-random',{attrs:{"loadedValues":_vm.value.values,"min":_vm.min,"max":_vm.max},on:{"valuesUpdated":_vm.updateValues}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }